import '@/js/smooth-scroll.js';
import { loadImages, autoLoadComponents } from '@/js/utils/auto-loader.js';

// Initialize shared loaders
const images = loadImages();

import '@/js/woningaanbod-page.js';
import '@/css/main.scss';

const components = autoLoadComponents();

// Block labels (only active when logged in)
import '@/js/block-labels.js';